<template>
  <circle cx="18.5" cy="18.5" r="18.5" fill="#FFED00" />
  <path
    d="M18.0088 22.6455L18.0088 19.0091"
    stroke="#233F1F"
    stroke-width="1.5"
    stroke-linecap="round" />
  <path
    d="M18.0088 15.364L17.9997 15.374"
    stroke="#233F1F"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round" />
  <circle cx="19" cy="19" r="9.25" stroke="#233F1F" stroke-width="1.5" />
</template>
